exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-e8f6fbc4]{width:1050px;margin:50px auto;border:1px solid #eee}.link_a[data-v-e8f6fbc4]{border-bottom:1px solid red}.bor_style[data-v-e8f6fbc4]:not(:last-child){margin-left:-18px;margin-right:-18px;border-bottom:1px solid #eadadd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-e8f6fbc4","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/skan_agreement/skan_category_brand.vue
// module id = 433
// module chunks = 0